/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import {Breakpoint} from "./interfaces";
import {warn} from "./miscUtil";

export const getScreenWidth = (includeScrollBars: boolean = false): number => {
    if (includeScrollBars)
        return document.documentElement.offsetWidth || 0;
    return Math.min(document.documentElement.clientWidth, window.innerWidth || 0);
};

export const getScreenHeight = (): number => Math.min(document.documentElement.clientHeight, window.innerHeight || 0);

export const getBreakPoint = (): Breakpoint => {
    const screenWidth: number = getScreenWidth();
    if (screenWidth >= Breakpoint.XL) return Breakpoint.XL;
    if (screenWidth >= Breakpoint.LG) return Breakpoint.LG;
    if (screenWidth >= Breakpoint.MD) return Breakpoint.MD;
    if (screenWidth >= Breakpoint.SM) return Breakpoint.SM;
    return Breakpoint.XS;
};

export const deviceIsMobile = (): boolean => {
    return window.matchMedia(`(max-width: ${Breakpoint.SM}px)`).matches;
};

export const matchBreakpoint = (breakPoint: Breakpoint, matchType: 'less' | 'more' = 'less',
                                allowEqual: boolean = true): boolean => {
    if (breakPoint === Breakpoint.XS) warn(
        'Do not use Breakpoint.XS for matching breakpoints. Breakpoint.XS is equal to 0');
    const actualBreakpoint: Breakpoint = getBreakPoint();
    if (breakPoint === actualBreakpoint) return allowEqual;
    else if (matchType === 'less') return actualBreakpoint < breakPoint;
    else return actualBreakpoint > breakPoint;
};